import { textFieldClasses } from '@mui/material/TextField';
import { inputBaseClasses } from '@mui/material/InputBase';
import Popover, { popoverClasses } from '@mui/material/Popover';
import Button, { buttonClasses } from '@mui/material/Button';
import { alpha, styled } from '@mui/material/styles';
import SovosTypography from '../sovos-typography';
import SovosTextField from '../sovos-text-field';
export const accountTypes = {
  DEFAULT: 'default',
  PRODUCTION: 'production',
  TEST: 'test'
};
const getTaxYearBgColor = (palette, isCurrentYear, taxYear) => {
  if (taxYear) {
    var _palette$cyan$, _palette$orange$;
    return isCurrentYear ? (_palette$cyan$ = palette.cyan[200]) !== null && _palette$cyan$ !== void 0 ? _palette$cyan$ : palette.info.light : (_palette$orange$ = palette.orange[200]) !== null && _palette$orange$ !== void 0 ? _palette$orange$ : palette.warning.light;
  }
  return 'transparent';
};
export const ToggleButton = styled(Button)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    borderRadius: 0,
    height: spacing(5),
    padding: 0,
    textTransform: 'none',
    width: '100%',
    ["&.".concat(buttonClasses.focusVisible)]: {
      color: alpha(palette.primary.contrastText, 0.4)
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  };
});
export const StyledPopover = styled(Popover)(_ref2 => {
  let {
    theme: {
      spacing
    }
  } = _ref2;
  return {
    ["& .".concat(popoverClasses.paper)]: {
      maxWidth: spacing(60),
      minWidth: spacing(30),
      paddingBlockStart: spacing(2),
      paddingBlockEnd: spacing()
    }
  };
});
export const ButtonContents = styled('div', {
  shouldForwardProp: prop => prop !== 'isButtonClickable' && prop !== 'selectedAccount'
})(_ref3 => {
  var _palette$orange$2, _palette$orange$3, _palette$cyan$2, _palette$cyan$3;
  let {
    isButtonClickable,
    selectedAccount,
    theme: {
      palette,
      shape,
      spacing,
      typography,
      transitions: {
        duration: {
          short: transitionDuration
        }
      }
    }
  } = _ref3;
  const {
    isCurrentYear,
    taxYear
  } = selectedAccount;
  const buttonColors = {
    defaultBg: alpha(palette.primary.light, 0.08),
    defaultBgHover: alpha(palette.primary.light, 0.12),
    taxYear: (_palette$orange$2 = palette.orange[600]) !== null && _palette$orange$2 !== void 0 ? _palette$orange$2 : palette.warning.dark,
    taxYearHover: (_palette$orange$3 = palette.orange[500]) !== null && _palette$orange$3 !== void 0 ? _palette$orange$3 : palette.warning.light,
    currentTaxYear: (_palette$cyan$2 = palette.cyan[700]) !== null && _palette$cyan$2 !== void 0 ? _palette$cyan$2 : palette.info.dark,
    currentTaxYearHover: (_palette$cyan$3 = palette.cyan[600]) !== null && _palette$cyan$3 !== void 0 ? _palette$cyan$3 : palette.info.light
  };
  const getBackgroundColor = () => {
    if (selectedAccount && taxYear) {
      return isCurrentYear ? buttonColors.currentTaxYear : buttonColors.taxYear;
    }
    return buttonColors.defaultBg;
  };
  const getHoverBg = () => {
    if (taxYear) {
      return isCurrentYear ? buttonColors.currentTaxYearHover : buttonColors.taxYearHover;
    }
    return buttonColors.defaultBgHover;
  };
  return {
    '&.SovosAccountSwitcher': {
      '&__buttonContents': {
        ...typography.subtitle1,
        alignItems: 'center',
        backgroundColor: getBackgroundColor(),
        border: 0,
        borderRadius: spacing(4),
        color: palette.primary.contrastText,
        cursor: isButtonClickable ? 'pointer' : 'default',
        display: 'flex',
        fontWeight: 700,
        height: spacing(5),
        justifyContent: 'start',
        marginBlockStart: 0,
        paddingBlock: 0,
        paddingInlineEnd: taxYear ? 0 : spacing(),
        paddingInlineStart: spacing(2.5),
        transition: "background-color ".concat(transitionDuration, "ms"),
        width: '100%',
        '&:hover': {
          backgroundColor: getHoverBg(),
          '& .SovosAccountSwitcher__year': {
            backgroundColor: (() => {
              if (taxYear && isCurrentYear) {
                return palette.cyan[100];
              }
              if (taxYear) {
                return palette.orange[100];
              }
              return 'transparent';
            })()
          }
        },
        '&--minimized': {
          backgroundColor: taxYear ? 'transparent' : buttonColors.defaultBg,
          borderRadius: shape.borderRadius,
          justifyContent: taxYear ? 'start' : 'center',
          padding: 0,
          marginInlineEnd: 0,
          '&:hover': {
            backgroundColor: taxYear ? 'transparent' : buttonColors.defaultBgHover
          },
          '& .SovosAccountSwitcher__year': {
            borderRadius: shape.borderRadius,
            justifyContent: 'center',
            padding: 0,
            width: '100%'
          }
        }
      }
    },
    '& .SovosAccountSwitcher': {
      '&__buttonContentsLabel': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        lineHeight: 1.2,
        textAlign: 'start',
        width: '100%'
      },
      '&__name': {
        flexGrow: '1'
      },
      '&__dropdownIndicator': {
        height: spacing(2.5),
        width: spacing(2.5)
      }
    }
  };
});
export const StyledMenuItem = styled('div')(_ref4 => {
  let {
    theme: {
      spacing
    }
  } = _ref4;
  return {
    display: 'flex',
    flexGrow: 1,
    maxWidth: '100%',
    '& .text': {
      paddingRight: spacing(1.5),
      flexGrow: 1
    }
  };
});
export const SearchWrapper = styled('div')(_ref5 => {
  let {
    theme: {
      spacing
    }
  } = _ref5;
  return {
    marginBlockStart: 0,
    marginBlockEnd: spacing(),
    marginInline: spacing()
  };
});
export const SearchField = styled(SovosTextField)(_ref6 => {
  let {
    theme: {
      spacing
    }
  } = _ref6;
  return {
    ["&.".concat(textFieldClasses.root)]: {
      minHeight: 'auto'
    },
    ["& .".concat(inputBaseClasses.adornedStart)]: {
      paddingInlineStart: spacing()
    }
  };
});
export const TreeListWrapper = styled('div')({
  maxHeight: 'calc(100vh - 240px)',
  overflow: 'auto'
});
export const NoResults = styled('div')(_ref7 => {
  let {
    theme: {
      palette,
      spacing,
      typography
    }
  } = _ref7;
  return {
    ...typography.body1,
    alignItems: 'center',
    color: palette.text.secondary,
    display: 'flex',
    height: spacing(5),
    justifyContent: 'center',
    margin: spacing()
  };
});
export const ButtonTaxYear = styled(SovosTypography, {
  shouldForwardProp: prop => prop !== 'isCurrentYear' && prop !== 'taxYear'
})(_ref8 => {
  let {
    theme: {
      palette,
      spacing,
      transitionDuration,
      typography
    },
    isCurrentYear,
    taxYear
  } = _ref8;
  return {
    alignItems: 'center',
    backgroundColor: getTaxYearBgColor(palette, isCurrentYear, taxYear),
    borderStartEndRadius: spacing(4),
    borderEndEndRadius: spacing(4),
    color: palette.text.primary,
    display: 'flex',
    height: spacing(5),
    paddingInlineEnd: spacing(2),
    paddingInlineStart: spacing(),
    transition: "background-color ".concat(transitionDuration, "ms"),
    '& .SovosAccountSwitcher__taxYear': {
      fontWeight: typography.body1.fontWeight,
      '& b': {
        fontWeight: 700
      }
    }
  };
});
export const ItemTaxYear = styled('span', {
  shouldForwardProp: prop => prop !== 'isCurrentYear'
})(_ref9 => {
  var _palette$cyan$4, _palette$orange$4;
  let {
    theme: {
      palette
    },
    isCurrentYear
  } = _ref9;
  return {
    color: isCurrentYear ? (_palette$cyan$4 = palette.cyan[700]) !== null && _palette$cyan$4 !== void 0 ? _palette$cyan$4 : palette.info.dark : (_palette$orange$4 = palette.orange[600]) !== null && _palette$orange$4 !== void 0 ? _palette$orange$4 : palette.warning.dark
  };
});
export const ButtonHighlight = styled('span')(_ref10 => {
  let {
    theme: {
      palette,
      spacing,
      shape: themeShape
    }
  } = _ref10;
  return {
    backgroundColor: palette.text.contrast,
    borderRadius: themeShape.borderRadiusSmall,
    color: palette.text.primary,
    paddingInline: spacing(0.5)
  };
});
export const MenuItemHighlight = styled('span')(_ref11 => {
  let {
    theme: {
      palette
    }
  } = _ref11;
  return {
    backgroundColor: palette.text.secondary,
    borderRadius: 2,
    color: palette.text.contrast
  };
});